import type { SearchResults, SearchResultItemWithKey } from '@sparkai/shared-types'

import { create } from 'zustand'

export type { SearchResults, SearchResultItemWithKey, SearchResultKeys } from '@sparkai/shared-types'

export interface SearchState {
  query: string
  setQuery: (query: string) => void

  results: SearchResults
  setResults: (results: SearchResults) => void

  recent: SearchResultItemWithKey[]
  addRecent: (item: SearchResultItemWithKey) => void

  isOpen: boolean
  openSearch: () => void
  closeSearch: () => void
  clearRecent: () => void
}

const DEFAULT_EMPTY_RESULTS: SearchResults = {
  engagements: [],
  operators: [],
  orgs: [],
  programs: [],
  systems: [],
}

export const useSearchStore = create<SearchState>((set, get) => ({
  query: '',
  setQuery: (query) => {
    set({ query })
  },

  results: DEFAULT_EMPTY_RESULTS,
  setResults: (results) => {
    set({ results })
  },

  recent: JSON.parse(localStorage.getItem('search-recent') || '[]'),
  clearRecent: () => {
    localStorage.removeItem('search-recent')
    set({ recent: [] })
  },
  addRecent: (item) => {
    const recent: SearchResultItemWithKey[] = get().recent

    if (recent.filter((recent) => recent.key === item.key && recent.id === item.id).length > 0) return

    if (recent.length >= 15) {
      recent.shift()
    }

    recent.push(item)
    localStorage.setItem('search-recent', JSON.stringify(recent))

    set({ recent })
  },

  isOpen: false,
  openSearch: () => {
    set({ isOpen: true })
  },
  closeSearch: () => {
    set({ isOpen: false })
  },
}))
